document.addEventListener('DOMContentLoaded', () => {
  // Function to smoothly scroll to an element
  function scrollToElement(element, callback) {
    // If the element doesn't exist, invoke the callback and return
    if (!element) return callback()

    // Smooth scroll to the element's position
    const offset = document.querySelector('.site-header')?.offsetHeight || 0
    window.scrollTo({
      behavior: 'smooth',
      top: element.offsetTop - offset
    })

    // Listen for scroll completion
    let scrollTimeout
    const scrollListener = () => {
      clearTimeout(scrollTimeout)
      scrollTimeout = setTimeout(() => {
        callback()
        window.removeEventListener('scroll', scrollListener)
      }, 100)
    }

    scrollListener()
    window.addEventListener('scroll', scrollListener)
  }

  // Function to handle scrolling through the timeline
  function scrollTimeline() {
    // Select all elements with class 'js-group-timeline'
    const timelineEls = document.querySelectorAll('.js-group-timeline')
    // If no timeline elements are found, return
    if (!timelineEls.length) return

    let isScrolling = false
    let scrollTimeout
    let lastScroll = 0

    // Add scroll event listener to the window
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout)

      // If already scrolling, do nothing
      if (isScrolling) return

      // Get the current scroll position
      const currentScroll = window.scrollY
      const windowHeight = window.innerHeight

      // Only check the timeline elements when the user stops scrolling
      scrollTimeout = setTimeout(() => {
        timelineEls.forEach((el, index) => {
          // Get the section containing the timeline element
          const section = el.closest('.shopify-section')
          // Get the next section, if available
          const nextSection = timelineEls[index + 1] ? timelineEls[index + 1].closest('.shopify-section') : null
          const sectionTop = section.offsetTop
          const sectionBottom = sectionTop + section.offsetHeight

          // Check if the breakpoint is within the section's bounds
          if (currentScroll >= sectionTop && currentScroll <= sectionBottom) {
            // Scroll to next section if the user scrolls down and the breakpoint is within the bottom 50% of the section
            const isScrollDown = currentScroll > lastScroll && nextSection && sectionBottom < currentScroll + windowHeight / 100 * 50
            // Scroll to the current section if the user scrolls up and the breakpoint is within the top 40% of the section
            const isScrollUp = currentScroll < lastScroll && nextSection && sectionBottom > currentScroll + windowHeight / 100 * 60

            // If not match up/down condition, do nothing
            if (!isScrollUp && !isScrollDown) return

            isScrolling = true
            scrollToElement(isScrollDown ? nextSection : section, () => {
              isScrolling = false
            })
            return
          }
        })

        // Save the last scroll to determine scroll direction
        lastScroll = currentScroll <= 0 ? 0 : currentScroll
      }, 100)
    })
  }

  // Call the scrollTimeline function when the page is loaded
  window.addEventListener('load', scrollTimeline)
})
